"use strict";

import * as React from 'react';
/**
 * Context which holds the navigation prop for a screen.
 */
export const NavigationContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=NavigationContext.js.map